module.exports = __webpack_public_path__ + "static/media/lena4.b4b34a3d.jpg";